import React from 'react';
import { CheckCircle, Clock, Wrench } from 'lucide-react';
import { areasServicio } from '../mock';

const AreaMantencion = () => {
  const area = areasServicio.mantencion;

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="hero-section py-24">
        <div className="container mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-white">
              <div className="inline-block mb-6">
                <span className="px-4 py-2 bg-yellow-400/20 text-yellow-400 rounded-full text-sm font-semibold backdrop-blur-sm border border-yellow-400/30">
                  Mantenimiento Especializado
                </span>
              </div>
              <h1 className="text-5xl lg:text-6xl font-bold heading-font mb-6">
                {area.titulo}
              </h1>
              <p className="text-xl text-gray-200 leading-relaxed">
                {area.descripcion}
              </p>
            </div>
            <div className="relative">
              <img
                src={area.imagen}
                alt={area.titulo}
                className="rounded-2xl shadow-2xl"
              />
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full bg-gradient-to-br from-blue-500/20 to-yellow-500/20 rounded-2xl blur-3xl"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Servicios */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold heading-font mb-4">
              Servicios de Mantención
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Mantenimiento preventivo y correctivo para garantizar el funcionamiento óptimo
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto">
            {area.servicios.map((servicio, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow"
              >
                <CheckCircle className="w-6 h-6 text-green-500 mt-1 flex-shrink-0" />
                <p className="text-gray-700 font-medium">{servicio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/*{/* Tipos de Mantenimiento 
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold heading-font mb-4">
              Nuestros Planes de Mantenimiento
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {/* Preventivo *
            <div className="bg-white rounded-2xl p-10 shadow-xl">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center mb-6">
                <Clock className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-bold heading-font mb-4">Mantenimiento Preventivo</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Programa de mantenimiento programado para evitar fallas y prolongar la vida útil de tus instalaciones.
              </p>
              <ul className="space-y-3">
                {[
                  'Inspección periódica programada',
                  'Termografía infrarroja',
                  'Mediciones eléctricas',
                  'Limpieza de equipos',
                  'Ajuste de conexiones',
                  'Reportes detallados'
                ].map((item, idx) => (
                  <li key={idx} className="flex items-center space-x-2">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Correctivo 
            <div className="bg-white rounded-2xl p-10 shadow-xl">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-yellow-500 to-yellow-600 flex items-center justify-center mb-6">
                <Wrench className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-3xl font-bold heading-font mb-4">Mantenimiento Correctivo</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Respuesta rápida ante fallas y emergencias, disponible 24/7 para resolver cualquier problema.
              </p>
              <ul className="space-y-3">
                {[
                  'Atención de emergencias 24/7',
                  'Diagnóstico rápido de fallas',
                  'Reparación inmediata',
                  'Reemplazo de componentes',
                  'Restauración del servicio',
                  'Garantía del trabajo'
                ].map((item, idx) => (
                  <li key={idx} className="flex items-center space-x-2">
                    <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0" />
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>*/}

      {/* Beneficios 
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold heading-font mb-4">
              Beneficios del Mantenimiento
            </h2>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            {[
              { title: 'Ahorro de Costos', desc: 'Previene reparaciones costosas' },
              { title: 'Mayor Seguridad', desc: 'Reduce riesgos eléctricos' },
              { title: 'Eficiencia Energética', desc: 'Optimiza consumo eléctrico' },
              { title: 'Vida Útil', desc: 'Prolonga duración de equipos' }
            ].map((benefit, idx) => (
              <div key={idx} className="text-center">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-blue-100 to-blue-200 flex items-center justify-center mx-auto mb-4">
                  <CheckCircle className="w-10 h-10 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold heading-font mb-2">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>}

      {/* CTA */}
      <section className="py-20 bg-gradient-to-br from-blue-900 to-blue-950 text-white">
        <div className="container mx-auto px-4 text-center">
          <Wrench className="w-16 h-16 text-yellow-400 mx-auto mb-6" />
          <h2 className="text-4xl lg:text-5xl font-bold heading-font mb-6">
            ¿Necesitas Mantenimiento?
          </h2>
          <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto">
            Consulta por nuestros planes de mantenimiento preventivo y correctivo
          </p>
          <a href="/contacto">
            <button className="btn-primary text-lg px-8 py-4">
              Solicitar Información
            </button>
          </a>
        </div>
      </section>
    </div>
  );
};

export default AreaMantencion;